import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  provideKeycloak,
  withAutoRefreshToken,
  AutoRefreshTokenService,
  UserActivityService
} from 'keycloak-angular';
import { routes } from './app.routes';
import { authInterceptor } from './core/auth';
import { environment } from '../environments/environment';

/**
 * Application configuration with providers.
 *
 * Configures:
 * - Router with application routes
 * - HttpClient with auth interceptor
 * - Keycloak authentication with auto-refresh token support
 *
 * Keycloak settings:
 * - Uses `check-sso` to silently check login state on load
 * - Disables login iframe for cross-domain compatibility
 * - Preserves URL path for deep linking after authentication
 * - Auto-refreshes tokens with 5-minute session timeout
 */
export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideKeycloak({
      config: environment.keycloak,
      initOptions: {
        onLoad: 'check-sso',
        checkLoginIframe: false,
        // Preserve path (e.g., /yearbooks/22) and query params for deep linking after auth
        // Exclude hash fragment — Keycloak uses response_mode=fragment for OAuth callbacks
        redirectUri: window.location.origin + window.location.pathname + window.location.search,
      },
      features: [
        withAutoRefreshToken({
          sessionTimeout: 86400000, // 24 hours — keep refreshing tokens while tab is open
          onInactivityTimeout: 'none',
          loginOptions: {idpHint: environment.keycloak.idpHint},
        }),
      ],
      providers: [AutoRefreshTokenService, UserActivityService],
    }),
  ],
};
